// extracted by mini-css-extract-plugin
export default {"root":"logo_root__5pzBw","icon":"logo_icon__XJj02","iconText":"logo_iconText__O3DeX","text":"logo_text__4v+q-"};